import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Slide } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';

import DeleteIcon from '@material-ui/icons/Delete';

function Transition (props) {
  return <Slide direction='down' {...props} />;
}

const styles = () => ({
  dialog: {
    zIndex: 1320, // necessário pois deve ser carregado sobre um Modal
  },
});

class DialogSlideGlosas extends React.Component {
  render () {
    const { classes, open, title, glosas, emAuditoria, handleClose, handleExcluirGlosa } = this.props;

    return (
      <React.Fragment>
        <Dialog
          open={open}
          className={classes.dialog}
          TransitionComponent={Transition}
          disableBackdropClick
          onClose={handleClose}
        >
          <DialogTitle>
            {title[0]}: {title[1]}
          </DialogTitle>
          <Divider />
          <DialogContent>
            <List dense>
              {glosas.map((glosa, idx) =>
                <ListItem key={idx}
                  // disabled={!emAuditoria}
                  title={emAuditoria && 'Excluir Glosa'}
                >
                  <ListItemText
                    primary={glosa.codMensagemGlosa + ' - ' + glosa.desMensagemGlosa}
                    secondary={
                      glosa.txtObservacao !== undefined && glosa.txtObservacao !== '' && glosa.txtObservacao !== null
                        ? `Observação: ' ${glosa.txtObservacao}`
                        : `Não há observações`}
                  />
                  {emAuditoria &&
                  <ListItemSecondaryAction>
                    <IconButton
                      onClick={() => handleExcluirGlosa(glosa.codMensagemGlosa)}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                  }
                </ListItem>
              )}
            </List>
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button id={'fechar'} onClick={handleClose} color='primary'>
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(DialogSlideGlosas);
